import axios from "axios";
import { baseURL } from "./CommonUrl";
import { toast } from "react-toastify";

export const headerToken = () => {
    const token = JSON.parse(localStorage.getItem("token_gw"));
    if (!token) {
        //console.error("No token found in localStorage.");
        return {};
    }
    return {
        headers: {
            "Authorization": `Bearer ${token}`,
            "Time-Zone": Intl.DateTimeFormat().resolvedOptions().timeZone
        }
    };
}

let setAuthModalFn = null;

export const registerAuthModal = (fn) => {
    setAuthModalFn = fn;
};

export const handleUnauthorized = () => {
    if (typeof setAuthModalFn === 'function') {
        setAuthModalFn(true);
    } else {
        console.warn("Auth modal not registered.");
    }
};

export const apiRequest = async (method, url, data = null, cb) => {
    try {
        const config = {
            method,
            url: baseURL + url,
            ...headerToken(),
            ...(method !== "GET" && { data }),
        };

        const response = await axios(config);
        
        return cb({
            status: 200,
            data: response.data,
        });
    } catch (err) {
        const statusCode = err.response?.status || 500;
        const errorData = err.response?.data || err.message;

        if (err.code === "ECONNABORTED" || err.message.includes("Network Error")) {
            toast.error("Network error. Please check your internet connection.")
        }

        if (statusCode === 401) {
            handleUnauthorized();
        }

        return cb({
            status: statusCode,
            data: errorData,
        });
    }
};
